import { createPreviewOverride } from "@/lib/core/client-flags/create-preview-override";

export function parseContactTextKitsPreview(value: string | null) {
    return value === "1" ? "treatment" : value === "0" ? "control" : null;
}

export const useContactTextKitsPreview = createPreviewOverride({
    param: "contactTextKits",
    key: "contact-text-kits-preview",
    parse: parseContactTextKitsPreview,
});
